<div class="pd-regles">
  <div class="d-flex flex-wrap justify-content-between mb-3 gap-2">
    <div>
      <h6 class="mb-0">Règles conditionnelles</h6>
      <p class="mb-0 text-muted small">Si / alors sur les champs du module.</p>
    </div>
    <button
      type="button"
      class="btn rippleEffect"
      style="background: rgba(19, 74, 211, 1); color: rgba(255, 255, 255, 1)"
      (click)="openAdd()"
    >
      <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Ajouter une règle
    </button>
  </div>


  <div class="parametre-donnees-dt-wrap pd-regles__table-shell mb-2">
    <div class="table-responsive">
      <table class="table table-hover mb-0 pd-regles__table">
        <thead class="custom-header">
          <tr>
            <th>Champ source</th>
            <th>Opérateur</th>
            <th>Valeur</th>
            <th>Action</th>
            <th>Champ cible</th>
            <th>Statut</th>
            <th class="text-right" style="width: 140px">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of rows">
            <td><code class="small">{{ r.champSource }}</code></td>
            <td>{{ r.operateur }}</td>
            <td>{{ r.valeur }}</td>
            <td>{{ r.action }}</td>
            <td><code class="small">{{ r.champCible }}</code></td>
            <td>
              <span class="badge" [ngClass]="r.statut === 'active' ? 'badge-success' : 'badge-secondary'">
                {{ r.statut === 'active' ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="text-right">
              <div ngbDropdown container="body" class="d-inline-block">
                <button
                  type="button"
                  class="btn btn-sm btn-link p-0"
                  ngbDropdownToggle
                  aria-label="Actions"
                >
                  <i class="bi bi-three-dots-vertical" aria-hidden="true"></i>
                </button>
                <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
                  <button type="button" ngbDropdownItem class="w-100 d-block text-start" (click)="openEdit(r)">
                    Modifier
                  </button>
                  <button
                    type="button"
                    ngbDropdownItem
                    class="w-100 d-block text-start text-danger"
                    (click)="delete(r)"
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="rows.length === 0" class="text-center text-muted py-4 small">Aucune règle.</div>
  </div>
</div>

<ng-template #regleModalTpl let-modal>
  <div class="modal-header" style="background: transparent">

    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body" *ngIf="editing" style="padding: 30px 64px 64px">
      <h2 class="modal-title text-center">{{ isNew ? 'Ajouter une règle' : 'Modifier la règle' }}</h2>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label>Champ source</label>
        <select class="form-control" [(ngModel)]="editing.champSource" name="cs">
          <option *ngFor="let c of champCodes" [value]="c">{{ c }}</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label>Opérateur</label>
        <select class="form-control" [(ngModel)]="editing.operateur" name="op">
          <option *ngFor="let o of operateurs" [value]="o">{{ o }}</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <label>Valeur de comparaison</label>
      <input class="form-control" [(ngModel)]="editing.valeur" name="val" />
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label>Action</label>
        <select class="form-control" [(ngModel)]="editing.action" name="act">
          <option *ngFor="let a of actions" [value]="a">{{ a }}</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label>Champ cible</label>
        <select class="form-control" [(ngModel)]="editing.champCible" name="cc">
          <option *ngFor="let c of champCodes" [value]="c">{{ c }}</option>
        </select>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label>Priorité</label>
        <input type="number" class="form-control" [(ngModel)]="editing.priorite" name="pri" />
      </div>
      <div class="form-group col-md-6 d-flex align-items-end">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="r-act" [(ngModel)]="editing.active" name="active" />
          <label class="custom-control-label" for="r-act">Active</label>
        </div>
      </div>
    </div>
      <div class=" justify-content-center p-0" style="display: flex;flex-wrap: wrap;align-items: center;justify-content: flex-end;gap: 12px;margin-top: 12px">
          <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>
          <button type="button" class="btn btn-primary" (click)="save(modal)">Enregistrer</button>
      </div>
  </div>

</ng-template>
